import rootApi from '@utils/baseAPI/WrapperApi';

export const apiGetCustomerWaterConsumptions = (params) =>
  rootApi.get('api/customer-water-consumptions', { params });

export const apiExportCustomerWaterConsumptions = (params) =>
  rootApi.get('api/customer-water-consumptions/export', {
    params,
    responseType: 'blob'
  });
